import { Outlet } from 'react-router-dom'
import { Navbar } from './Navbar'
import { Footer } from './Footer'
import { ScrollToTop } from './ScrollToTop'
import { WhatsAppButton } from '../WhatsAppButton'

function Layout() {
  return (
    <div className="min-h-screen bg-[#020813] relative selection:bg-cyan-500/30">
      <div className="relative z-10">
        <Navbar />
        <main>
          <Outlet />
        </main>
        <Footer />
        <WhatsAppButton />
        <ScrollToTop />
      </div>
    </div>
  )
}

export default Layout
